var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.9987 9.33325C8.73508 9.33325 9.33203 8.7363 9.33203 7.99992C9.33203 7.26354 8.73508 6.66659 7.9987 6.66659C7.26232 6.66659 6.66536 7.26354 6.66536 7.99992C6.66536 8.7363 7.26232 9.33325 7.9987 9.33325Z", stroke: "#767676", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M14.6654 7.99992C12.8874 11.1113 10.6654 12.6666 7.9987 12.6666C5.33203 12.6666 3.11003 11.1113 1.33203 7.99992C3.11003 4.88859 5.33203 3.33325 7.9987 3.33325C10.6654 3.33325 12.8874 4.88859 14.6654 7.99992Z", stroke: "#767676", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});